import { useEffect, useState } from 'react';
import api from '@/utils/api';

interface TwitterTokenStatus {
  hasToken: boolean;
  isExpired: boolean;
  expiresAt: string | null;
  hasPostingAccess: boolean;
  username: string | null;
}

export const useTwitterTokenStatus = () => {
  const [status, setStatus] = useState<TwitterTokenStatus>({
    hasToken: false,
    isExpired: false,
    expiresAt: null,
    hasPostingAccess: false,
    username: null,
  });
  const [isLoading, setIsLoading] = useState(true);

  const fetchStatus = async () => {
    try {
      setIsLoading(true);
      const response = await api.get('/users/twitter-token-status');
      setStatus(response.data);
    } catch (error) {
      console.error('Failed to fetch Twitter token status:', error);
      setStatus({
        hasToken: false,
        isExpired: false,
        expiresAt: null,
        hasPostingAccess: false,
        username: null,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  return {
    hasToken: status.hasToken,
    isExpired: status.isExpired,
    expiresAt: status.expiresAt,
    hasPostingAccess: status.hasPostingAccess,
    username: status.username,
    isLoading,
    refetch: fetchStatus,
  };
};
